__turbopack_context__.v({
  "continuarBtn": "Step2UsuarioForm-module__CXX-sq__continuarBtn",
  "countryCodeBtn": "Step2UsuarioForm-module__CXX-sq__countryCodeBtn",
  "formContainer": "Step2UsuarioForm-module__CXX-sq__formContainer",
  "formWrapper": "Step2UsuarioForm-module__CXX-sq__formWrapper",
  "helpBtn": "Step2UsuarioForm-module__CXX-sq__helpBtn",
  "highlightMarker": "Step2UsuarioForm-module__CXX-sq__highlightMarker",
  "highlightSvg": "Step2UsuarioForm-module__CXX-sq__highlightSvg",
  "inputError": "Step2UsuarioForm-module__CXX-sq__inputError",
  "inputField": "Step2UsuarioForm-module__CXX-sq__inputField",
  "phoneInput": "Step2UsuarioForm-module__CXX-sq__phoneInput",
  "phoneInputWrapper": "Step2UsuarioForm-module__CXX-sq__phoneInputWrapper",
  "stepperContainer": "Step2UsuarioForm-module__CXX-sq__stepperContainer",
  "stepperNav": "Step2UsuarioForm-module__CXX-sq__stepperNav",
  "volverBtn": "Step2UsuarioForm-module__CXX-sq__volverBtn",
});
